import Papa from "papaparse";

export const rapidRailKLService = {
  getShapes,
  getRoutes,
  getStops,
  getStopTimes,
  getTrips
};

async function getShapes() {
  try {
    const response = await fetch("/rapid-rail-kl/shapes.txt");
    const textFile = await response.text();

    const shapes = await new Promise((resolve, reject) => {
      Papa.parse(textFile, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => resolve(result.data),
        error: (error) => reject(error),
      });
    });

    return shapes;
  } catch (error) {
    console.error("Error loading or parsing shapes.txt:", error);
    return [];
  }
}

async function getRoutes() {
  try {
    const response = await fetch("/rapid-rail-kl/routes.txt");
    const textFile = await response.text();

    const routes = await new Promise((resolve, reject) => {
      Papa.parse(textFile, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => resolve(result.data),
        error: (error) => reject(error),
      });
    });

    return routes;
  } catch (error) {
    console.error("Error loading or parsing routes.txt:", error);
    return [];
  }
}

async function getStops() {
  try {
    const response = await fetch("/rapid-rail-kl/stops.txt");
    const textFile = await response.text();

    const stops = await new Promise((resolve, reject) => {
      Papa.parse(textFile, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => resolve(result.data),
        error: (error) => reject(error),
      });
    });

    return stops;
  } catch (error) {
    console.error("Error loading or parsing stops.txt:", error);
    return [];
  }
}

async function getStopTimes() {
  try {
    const response = await fetch("/rapid-rail-kl/stop_times.txt");
    const textFile = await response.text();

    const result = await new Promise((resolve, reject) => {
      Papa.parse(textFile, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => resolve(result.data),
        error: (error) => reject(error),
      });
    });

    return result;
  } catch (error) {
    console.error("Error loading or parsing stops_times.txt:", error);
    return [];
  }
}
async function getTrips() {
  try {
    const response = await fetch("/rapid-rail-kl/trips.txt");
    const textFile = await response.text();

    const result = await new Promise((resolve, reject) => {
      Papa.parse(textFile, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => resolve(result.data),
        error: (error) => reject(error),
      });
    });

    return result;
  } catch (error) {
    console.error("Error loading or parsing trips.txt:", error);
    return [];
  }
}
